const actionTypeIdentifier = '0F370BD9-4D21-425C-B515-377C213AD8CE';

export const getCircuitEquipList = `GET-CIRCUIT-EQUIP-LIST-${actionTypeIdentifier}`;
export const getCircuitOrderEquipList = `GET-CIRCUIT-ORDER-EQUIP-LIST-${actionTypeIdentifier}`;
export const deleteCircuitEquipItem = `DELETE-CIRCUIT-EQUIP-ITEM-${actionTypeIdentifier}`;
export const addCircuitEquipItem = `ADD-CIRCUIT-EQUIP-ITEM-${actionTypeIdentifier}`;
export const updateCircuitEquipItem = `UPDATE-CIRCUIT-EQUIP-ITEM-${actionTypeIdentifier}`;
export const resetCircuitEquipDetails = `RESET-CIRCUIT-EQUIP-DETAILS-${actionTypeIdentifier}`;
export const onServiceModelSelect = `SET-CIRCUIT-EQUIP-SELECT-${actionTypeIdentifier}`;
export const getDeviceModelsAction = `GET-DEVICE-MODELS-${actionTypeIdentifier}`;
export const setDeviceModelsLoading = `SET-DEVICE-MODELS-LOADING-${actionTypeIdentifier}`;
export const getAccessoryModelsAction = `GET-ACCESSORY-MODELS-${actionTypeIdentifier}`;
export const setAccessoryModelsLoading = `SET-ACCESSORY-MODELS-LOADING-${actionTypeIdentifier}`;

export const circuitEquipFormModel = {
    ID: -1,
    TypeId: null,
    Type: null,
    Model: null,
    ModelId: null,
    IMEISerialNumber: null,
    AssetTagNumber: "",
    StatusId: null,
    Status: null,
    ProductName: null,
    PartCode: "",
    Price: "0.00",
    AdditionalInformation: ""
}